module.exports = __webpack_public_path__ + "img/features-ring-back.b8743211.svg";